// extracted by mini-css-extract-plugin
module.exports = {"image":"NextImage_image__qykvn"};